import { State } from 'modules';

export const getCollapsedDrawerSections = (state: State) =>
  state.ui.collapsibles;



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/collapsibles.ts